import React from "react";
import { Modal } from "antd";
import {
  TEXT,
  REASON_MODAL_WIDTH,
  REASON_TEXTAREA_ROWS,
} from "../../EmployeeSkillsBridgerV2.constants";
import {
  ReasonTextAreaStyled,
  REASON_MODAL_STYLES,
  REASON_OK_BUTTON_PROPS,
} from "./ReasonModal.styles";

const ReasonModal = ({ skillId, skill, reasonText, onCancel, onOk, onReasonChange, isSubmitting }) => {
  const hasText = Boolean(reasonText?.trim());

  return (
    <Modal
      open={skillId !== null}
      title={TEXT.REASON_MODAL_TITLE}
      onCancel={onCancel}
      onOk={(e) => onOk(e, skillId, skill?.profile_proficiency)}
      okText={TEXT.REASON_MODAL_OK}
      cancelText={TEXT.REASON_MODAL_CANCEL}
      okButtonProps={{
        ...(hasText && !isSubmitting ? REASON_OK_BUTTON_PROPS : {}),
        disabled: !hasText || isSubmitting,
        loading: isSubmitting,
      }}
      width={REASON_MODAL_WIDTH}
      destroyOnHidden
      styles={REASON_MODAL_STYLES}
    >
      <ReasonTextAreaStyled
        value={reasonText || ""}
        onChange={(e) => onReasonChange(skillId, e.target.value)}
        placeholder={TEXT.REASON_MODAL_PLACEHOLDER}
        rows={REASON_TEXTAREA_ROWS}
      />
    </Modal>
  );
};

export default ReasonModal;
